const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const resolveImageUrl = (src) => {
  if (!src) return '';
  if (src.startsWith('data:') || src.startsWith('http://') || src.startsWith('https://')) return src;
  if (src.startsWith('/api/')) return `${BACKEND_URL}${src}`;
  return src;
};

export function slugify(text) {
  return (text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 60) || 'anuncio';
}

export function shortId(id) {
  return (id || '').replace(/-/g, '').slice(0, 8);
}

// URL amigável e partilhável do anúncio.
export function listingUrl(item) {
  const tipo = item?.tipo === 'viatura' || item?.tipo === 'venda' ? 'viaturas' : 'motoristas';
  const base = item?.titulo || item?.cidade || 'anuncio';
  return `/${tipo}/${slugify(base)}-${shortId(item?.id)}`;
}
